import { ForecastNumbersMainValue } from './ForecastNumbersMainValue';
import { ForecastNumbersRoot } from './ForecastNumbersRoot';
import { ForecastNumbersSubValue } from './ForecastNumbersSubValue';

export const ForecastNumbers = {
  Root: ForecastNumbersRoot,
  MainValue: ForecastNumbersMainValue,
  SubValue: ForecastNumbersSubValue,
};
